import React, { useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    address: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = 'Contact Form Submission';
    const body = `Name: ${formData.name}%0D%0AMobile: ${formData.mobile}%0D%0AEmail: ${formData.email}%0D%0AAddress: ${formData.address}%0D%0AMessage: ${formData.message}`;
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=primeholidaylights@gmail.com&su=${subject}&body=${body}`, '_blank');
    setFormData({ name: '', mobile: '', email: '', address: '', message: '' });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name *"
            value={formData.name}
            onChange={handleChange}
            className="form-input w-full mb-3 p-3 border rounded-lg text-black"
            required
          />
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number *"
            value={formData.mobile}
            onChange={handleChange}
            className="form-input w-full mb-3 p-3 border rounded-lg text-black"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email *"
            value={formData.email}
            onChange={handleChange}
            className="form-input w-full mb-3 p-3 border rounded-lg text-black"
            required
          />
          <input
            type="text"
            name="address"
            placeholder="Address *"
            value={formData.address}
            onChange={handleChange}
            className="form-input w-full mb-3 p-3 border rounded-lg text-black"
            required
          />
          <textarea
            name="message"
            placeholder="Message *"
            value={formData.message}
            onChange={handleChange}
            className="form-input w-full mb-3 p-3 border rounded-lg h-24 text-black"
            required
          />
          <div className="flex gap-2">
            <button
              type="submit"
              className="btn-primary flex-1 text-white py-3 rounded-lg font-semibold"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-500 hover:bg-gray-600 text-white py-3 rounded-lg font-semibold transition-all duration-300"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;